<template>
  <v-card>
    <v-card-title primary-title style="margin: 0;padding: 0 5px;">
      <v-btn color="success" @click="addAction">新增</v-btn>
    </v-card-title>
    <v-container grid-list-md>
      <v-layout column>
        <v-layout align-center row v-for="(item, index) in model.actions" :key="index">
          <v-flex xs6 md3 lg1>
            <v-text-field v-model="item.value" label="值">

            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg2>
            <v-text-field v-model="item.icon" label="图标">
              <template #append>
                <v-fade-transition leave-absolute>
                  <v-icon :color="item.color">{{item.icon}}</v-icon>
                </v-fade-transition>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg2>
            <v-text-field v-model="item.text" label="文本">
            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg2>
            <v-text-field v-model="item.event" label="事件">
            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg1>
            <v-checkbox label="是否隐藏" v-model="item.hide"></v-checkbox>
            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg2>
            <v-autocomplete :items="['primary','secondary','success','error']" v-model="item.color" label="颜色">
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 md4 lg2>
            <v-btn style="margin: 0; padding: 0px" outline color="primary" icon @click.stop="insertAction(index)">
              插入
            </v-btn>
            <v-btn style="margin: 0; padding: 0px" outline color="success" v-show="index>0" icon
              @click.stop="moveUpAction(index)">
              <v-icon small>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn style="margin: 0; padding: 0px" outline color="success" v-show="index < (model.actions.length-1)"
              icon @click.stop="moveDownAction(index)">
              <v-icon small>mdi-arrow-down</v-icon>
            </v-btn>
            <v-btn style="margin: 0; padding: 0px" outline color="error" icon @click.stop="deleteAction(index)">
              <v-icon small>mdi-delete-forever-outline</v-icon>
          
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>

    </v-container>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import ActionsProperty from "./actionsProperty.ts";
  export default ActionsProperty;
</script>